import React, { useContext, useEffect, useState } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { Truck, Phone, Eye, EyeOff } from "lucide-react";
import "../../../assets/styles/distributor/DistributorSignUp.css";
import axios from "axios";
import Swal from "sweetalert2";
import AppContext from "../../../context/AppContext";

/* =============================================
   DATA
   ============================================= */
const CITIES = [
  "Lahore",
  "Karachi",
  "Islamabad",
  "Rawalpindi",
  "Faisalabad",
  "Multan",
  "Peshawar",
  "Quetta",
];

// const AREAS = [
//   "Lahore",
//   "Karachi",
//   "Islamabad",
//   "Rawalpindi",
//   "Faisalabad",
//   "Multan",
//   "Peshawar",
//   "Quetta",
// ];

// const AREAS = {
//   Lahore:     ["DHA Phase 5", "Gulberg III", "Model Town", "Johar Town", "Garden Town", "Bahria Town"],
//   Karachi:    ["Clifton", "DHA Karachi", "Gulshan-e-Iqbal", "North Nazimabad", "Korangi"],
//   Islamabad:  ["F-6", "F-7", "F-8", "G-9", "G-10", "E-7"],
//   Rawalpindi: ["Bahria Town", "Saddar", "Gulraiz", "Chaklala"],
//   Faisalabad: ["Peoples Colony", "Gulberg", "Canal Road", "Dijkot Road"],
//   Multan:     ["Cantt", "Shah Rukn-e-Alam", "Gulgasht Colony", "Bosan Road"],
//   Peshawar:   ["Hayatabad", "University Town", "Saddar", "Gulbahar"],
//   Quetta:     ["Satellite Town", "Jinnah Town", "Airport Road", "Zarghoon Road"],
// };

/* =============================================
   MAIN COMPONENT
   ============================================= */
const DistributorSignUp = () => {
  const navigate = useNavigate();

  // Local States (jaise aapne Step1 mein likhi thi)
  const [showPw, setShowPw] = useState(false);
  const [fullName, setFullName] = useState("");
  const [email, setEmail] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [password, setPassword] = useState("");
  const [cityId, setCityId] = useState("");
  const [areaId, setAreaId] = useState("");
  // const baseUrl = "http://127.0.0.1:8000/api";
  const {baseUrl} = useContext(AppContext);

  // Form State (combined object)
  // const [form, setForm] = useState({
  //   fullName: "",
  //   phone: "",
  //   email: "",
  //   password: "",
  //   city: "",
  //   area: "",
  // });

  // const handleChange = (field, value) => {
  //   setForm((prev) => ({ ...prev, [field]: value }));
  // };

  // const areas = city ? (AREAS[city] || []) : [];

  // const handleSubmit = () => {
  //   // TODO: connect to backend API
  //   console.log("Signup submitted:", {
  //     fullName, email, phoneNumber, password, cityid, areaid, // local states
  //     ...form,                                                  // form state
  //   });
  //   navigate("/distributor/dashboard");
  // };

  useEffect(() => {
    const distributorPhone = localStorage.getItem("distributorPhone");
    const distributorPassword = localStorage.getItem("distributorPassword");
    if (distributorPhone != null && distributorPassword != null) {
      // navigate("/distributor/dashboard");
      autoLogin(distributorPhone, distributorPassword);
    }
  }, []);

  const autoLogin = (distributorPhone, distributorPassword) => {
    const formData = new FormData();
    formData.append("phonenumber", distributorPhone);
    formData.append("password", distributorPassword);
    axios
      .post(
        // "http://127.0.0.1:8000/api/distributor/auth/loginDistributor",
        `${baseUrl}/distributor/auth/loginDistributor`,
        formData,
        {
          "Content-type": "multipart-formdata",
        },
      )
      .then((response) => {
        if (response.data.success === true) {
          console.log(response.data);
          navigate("/distributor/dashboard");
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const distributorSignup = () => {
    console.log("add distributor function called");
    console.log(fullName, email, password, phoneNumber, cityId, areaId);

    const formData = new FormData();
    formData.append("fullName", fullName);
    formData.append("email", email);
    formData.append("password", password);
    formData.append("phonenumber", phoneNumber);
    // formData.append("city_id",cityId);
    formData.append("city_id", 1);
    // formData.append("area_id",areaId);
    formData.append("area_id", 1);
    axios
      .post(`${baseUrl}/distributor/auth/createDistributor`, formData, {
        "Content-type": "multipart-formdata",
      })
      .then((response) => {
        if (response.data.success === true) {
          // console.log("Admin has been created successfuly");
          console.log(response.data.message);
          console.log(response.data);
          Swal.fire({
            title: "Congratulations!",
            text: "Your account has been created successfuly",
            icon: "success",
            confirmButtonText: "Cool",
          });
          localStorage.setItem("distributorPhone", phoneNumber);
          localStorage.setItem("distributorPassword", password);
          navigate("/distributor/dashboard");
        } else {
          Swal.fire({
            title: "Oops!",
            text: "Cannot Add create account at the moment",
            icon: "error",
            confirmButtonText: "Try Again",
          });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <div className="dist-signup-page">
      <Container fluid="sm">
        <Row className="justify-content-center">
          <Col xs={12} sm={10} md={8} lg={6} xl={5}>
            <div className="dist-signup-card">
              {/* Truck icon bubble */}
              <div className="dist-signup-icon-bubble">
                <Truck size={28} strokeWidth={1.6} />
              </div>

              {/* Heading */}
              <div className="dist-signup-heading">
                <h2>Become a Distributor</h2>
                <p>Join MilkyWay and grow your milk delivery business</p>
              </div>

              {/* Full Name */}
              <div className="dist-signup-field">
                <label>Full Name</label>
                <div className="dist-signup-input-wrap">
                  <input
                    className="dist-signup-input"
                    placeholder="Your full name"
                    value={fullName}
                    onChange={(e) => setFullName(e.target.value)}
                  />
                </div>
              </div>

              {/* Phone */}
              <div className="dist-signup-field">
                <label>
                  Phone Number <span className="dist-signup-required">*</span>
                </label>
                <div className="dist-signup-input-wrap">
                  <span className="dist-signup-input-icon">
                    <Phone size={15} />
                  </span>
                  <input
                    className="dist-signup-input has-icon"
                    placeholder="03XX-XXXXXXX"
                    value={phoneNumber}
                    onChange={(e) => setPhoneNumber(e.target.value)}
                  />
                </div>
              </div>

              {/* Email */}
              <div className="dist-signup-field">
                <label>
                  Email <span className="dist-signup-optional">(Optional)</span>
                </label>
                <div className="dist-signup-input-wrap">
                  <input
                    className="dist-signup-input"
                    type="email"
                    placeholder="admin@milkyway.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
              </div>

              {/* Password */}
              <div className="dist-signup-field">
                <label>Password</label>
                <div className="dist-signup-input-wrap">
                  <input
                    className="dist-signup-input"
                    type={showPw ? "text" : "password"}
                    placeholder="••••••••"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    style={{ paddingRight: "44px" }}
                  />
                  <button
                    className="dist-signup-pw-toggle"
                    type="button"
                    onClick={() => setShowPw((p) => !p)}
                  >
                    {showPw ? <EyeOff size={17} /> : <Eye size={17} />}
                  </button>
                </div>
              </div>

              {/* City + Area */}
              <div className="dist-signup-row-1">
                <div className="dist-signup-field" style={{ marginBottom: 0 }}>
                  <label>City</label>
                  <select
                    className="dist-signup-select"
                    value={cityId}
                    onChange={(e) => {
                      // handleChange("city", e.target.value);
                      // handleChange("area", "");
                      setCityId(e.target.value);
                      setAreaId("");
                    }}
                  >
                    <option value="">Select city</option>
                    {CITIES.map((c) => (
                      <option key={c} value={c}>
                        {c}
                      </option>
                    ))}
                  </select>
                </div>
                {/* <div className="dist-signup-field" style={{ marginBottom: 0 }}>
                  <label>Area</label>
                  <select
                    className="dist-signup-select"
                    value={areaId}
                    onChange={(e) => {
                      // handleChange("area", e.target.value);
                      setAreaId(e.target.value);
                    }}
                    disabled={!cityId}
                  >
                    <option value="">Select area</option>
                    {AREAS.map((a) => (
                      <option key={a} value={a}>
                        {a}
                      </option>
                    ))}
                    {areas.map((a) => <option key={a} value={a}>{a}</option>)} 
                  </select>
                </div> */}
              </div>

              {/* Sign Up Button */}
              <button
                className="dist-signup-btn-primary"
                style={{ marginTop: "22px" }}
                onClick={distributorSignup}
                type="button"
              >
                Sign Up
              </button>

              <div className="dist-signup-signin-row">
                Already have an account?{" "}
                <button
                  className="dist-signup-link"
                  onClick={() => navigate("/distributor-login")}
                >
                  Sign In
                </button>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default DistributorSignUp;
